<template>
  <v-dialog v-model="mostrar" persistent max-width="400px">
    <v-card>
      <v-toolbar
        color="blue-grey darken-1"
        dense
        dark
        flat
        class="text-h5"
        height="50px"
      >
        Eliminar de/para
      </v-toolbar>
      <v-container fluid style="margin-top: 15px">
        <h4>¿Está seguro de eliminar este de/para?</h4>
        <br />Esta acción acción no se podrá revertir.
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey darken-1"
          outlined
          small
          :disabled="loading"
          @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="red"
          :loading="loading"
          dark
          small
          @click="eliminarDepara()"
          >Eliminar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { eliminarDeparaService } from "./depara.service";

export default {
  name: "eliminarDepara",
  props: ["mostrar", "idDepara"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async eliminarDepara() {
      try {
        this.loading = true;
        const serverResponse = await eliminarDeparaService(this.idDepara);
        this.loading = false;

        if (!serverResponse.ok) throw Error(serverResponse.mensaje);
        else {
          //this.$router.go(-1);
          this.$router.push("/oficios/DePara?page=1&search=&filter=0");
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
  },
};
</script>